export const props = Symbol('props');

export const render = Symbol('render');

export const styles = Symbol('styles');

export const update = Symbol('update');
